import { useQuery } from 'react-query'
import { getOpportunityById } from '../../opportunities'

export default function useOpportunity(id: string) {
  const { data, error, isLoading } = useQuery(['opportunities', id], () =>
    getOpportunityById(id)
  )
  return { data, error, isLoading }
}
